export const menuItems = [
    { title: "Главная", link: "/main" },
    {
        title: "Программы",
        link: "/treatment",
        submenu: [
            {
                title: "Специальные программы",
                link: "/treatment",
                submenu: [
                    { title: "Постковид", link: "/treatment" },
                    { title: "Мужское здоровье", link: "/treatment" },
                    { title: "ЧЕК-АП после COVID-19", link: "/treatment" },
                    { title: "Программа по снижению веса", link: "/treatment" },
                    { title: "Программа «Анти-стресс»", link: "/treatment" },
                    { title: "Программа «Активация»", link: "/treatment" },
                    { title: "Физиотерапия аппаратная", link: "/treatment" },
                    { title: "Теплолечение", link: "/treatment" },
                ]
            },
        ]
    },
    {
        title: "Номера",
        link: "/rooms",
    },
    {
        title: "Услуги",
        link: "/food",
        submenu: [
            { title: "Досуг", link: "/food" },
            { title: "Инфраструктура", link: "/food" }
        ]
    },
    {title: "Информация",link: "/info",}
];